import elementSpy, { Bound } from '@hh.ru/browser-api-utils/lib/modules/elementSpy';
import { useExperimentGroupCheckFunction } from '../modules/experiments/useExperimentCheckFunction';
import useElementShown from './useElementShown';
/**
 * Хук для отправки участия в экспериментах при попадании элемента во вьюпорт
 *
 * Возвращает ref для размещения на нужном элементе
 *
 * При изменении параметров или маунте/анмаунте элемента событие переназначается
 */

const useExperimentCheckOnElementShown = ({
  onShow,
  trackingBounds = [Bound.Top],
  experimentNames,
  sendCheck = true
}) => {
  const getExperimentGroup = useExperimentGroupCheckFunction(sendCheck);
  return useElementShown(elementSpy, {
    onShow() {
      experimentNames.forEach(experimentName => getExperimentGroup(experimentName));
      if (onShow) {
        onShow();
      }
    },
    trackingBounds
  });
};
export default useExperimentCheckOnElementShown;
//# sourceMappingURL=useExperimentCheckOnElementShown.js.map